<template>
  <Header />
  <div class="container is-max-desktop no-indent">
    <vue-cal v-if="global.user.hasOwnProperty('id')" :events="events" :on-event-click="bookingOpen"
      :split-days="splitDays" :min-cell-width="minCellWidth" :min-split-width="minSplitWidth" locale="da"
      :disable-views="['years', 'year']" :active-view="activeView"
      :selected-date="selectedDate"
      :time-from="0" events-count-on-year-view="events-count-on-year-view" events-on-month-view="short"
      @ready="onCalendarDateChange"
      @view-change="onCalendarDateChange"
      @update:activeView="activeView = $event"
      @cell-click="onCellClick">
      <template v-slot:no-event="">&nbsp;</template>
    </vue-cal>
    <p v-if="global.user.hasOwnProperty('id')" class="calendar-legend is-size-7 has-text-grey-dark">
      <span class="calendar-legend__item">
        <span class="calendar-legend__swatch calendar-legend__swatch--own" aria-hidden="true"></span>
        Grøn markering = jeres konto
      </span>
    </p>
  </div>
  <div class="container is-max-desktop">
    <LoginStatus />
  </div>
  <Footer />
</template>

<script>
import ax from 'axios'
export const axios = ax

import { defineComponent } from 'vue'
import { useComposition } from '@/compositions/composition'

import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
import LoginStatus from '@/components/LoginStatus.vue'
import VueCal from 'vue-cal'
import 'vue-cal/dist/i18n/da.js';
import 'vue-cal/dist/vuecal.css'

export default defineComponent({
  setup() {
    const { global } = useComposition();
    return {
      global,
      apiRoot: process.env.VUE_APP_API_ROOT
    }
  },
  data() {
    return {
      minCellWidth: 130,
      minSplitWidth: 0,
      splitDays: [
        { id: 1, class: 'benzin', label: 'Benzin' },
        { id: 43, class: 'el', label: 'El' }
      ],
      events: [],
      // Stable initial date only – do not recreate Date() on each render (breaks prev/next)
      selectedDate: null,
      viewDate: null,
      activeView: 'day'
    }
  },
  components: {
    Header,
    Footer,
    LoginStatus,
    VueCal
  },
  created() {
    const initialDate = this.$route.query.selectedDate || this.formatDateYmd(new Date());
    this.selectedDate = initialDate;
    this.viewDate = initialDate;
    this.activeView = this.normalizeCalendarView(this.$route.query.view || this.global.navigation.calendarView);
    this.global.navigation.calendarDate = initialDate;
    this.global.navigation.calendarView = this.activeView;
    this.bookingsLoad();
  },
  mounted() {
    this.setCalendarHeight();
  },
  methods: {
    formatDateYmd(date) {
      const d = date instanceof Date ? date : new Date(date);
      if (Number.isNaN(d.getTime())) {
        return this.formatDateYmd(new Date());
      }
      const y = d.getFullYear();
      const m = String(d.getMonth() + 1).padStart(2, '0');
      const day = String(d.getDate()).padStart(2, '0');
      return `${y}-${m}-${day}`;
    },
    todayYmd() {
      return this.formatDateYmd(new Date());
    },
    normalizeCalendarView(view) {
      return ['day', 'week', 'month'].includes(view) ? view : 'day';
    },
    rememberCalendarNavigation(date) {
      this.global.navigation.navigatedFrom = 'Calendar';
      this.global.navigation.calendarView = this.activeView;
      this.global.navigation.calendarDate = date || this.viewDate || this.todayYmd();
    },
    onCalendarDateChange(view) {
      if (view && view.view) {
        this.activeView = this.normalizeCalendarView(view.view);
      }
      // Uge/måned-navigation: brug periodens første dag, indtil en specifik dag klikkes
      if (view && view.startDate) {
        this.viewDate = this.formatDateYmd(view.startDate);
        this.global.navigation.calendarDate = this.viewDate;
        this.global.navigation.calendarView = this.activeView;
      }
    },
    onCellClick(payload) {
      // Aktiv/markeret dag i uge- eller månedsvisning
      const date = payload && payload.date ? payload.date : payload;
      if (date) {
        this.viewDate = this.formatDateYmd(date);
        this.global.navigation.calendarDate = this.viewDate;
      }
    },
    bookingsLoad() {
      axios.get(process.env.VUE_APP_API_ROOT + '/bookings.php')
        .then(response => {
          const events = Array.isArray(response.data) ? response.data : [];
          this.events = events.map(event => {
            if (event.class !== 'is-own-account') {
              return event;
            }
            return {
              ...event,
              content: '<span class="booking-own-badge">Jeres konto</span>'
            };
          });
        })
    },
    bookingOpen(event, e) {
      const eventDate = event && event.start ? this.formatDateYmd(event.start) : this.viewDate;
      this.rememberCalendarNavigation(eventDate);
      this.$router.push('/booking/' + event.id);
      e.stopPropagation()
    },
    setCalendarHeight() {
      var appHeader = document.getElementsByTagName('header');
      var vueCalHeader = document.getElementsByClassName('vuecal__header');
      var vueCalBody = document.getElementsByClassName('vuecal__body');

      if (appHeader.length > 0 && vueCalHeader.length > 0 && vueCalBody.length > 0) {
        let heightAppHeader = appHeader[0].offsetHeight;
        let heightVueCalHeader = vueCalHeader[0].offsetHeight;
        let heightVueCalBody = vueCalBody[0].offsetHeight;

        let newHeightVueCalBody = window.innerHeight - (heightAppHeader + heightVueCalHeader);
        vueCalBody[0].setAttribute("style", 'height: ' + newHeightVueCalBody + 'px');
      }
    }
  },
  computed: {
    currentRoute() {
      return this.$route;
    }
  }
})

</script>